import { IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IMultiOccurrenceOptions } from "../../../../../core/services/multi-occurrence.service";
//import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireClass } from "../../../../../core/services/formulaire/formulaire.service";
import { IFormulaireItemClass } from "../../../../../core/services/formulaire/formulaire-item.service";
import IStateService = angular.ui.IStateService;
import { IRoute } from "../../../../../core/interfaces/route.interface";
import { IFilterExDate } from "../../../../../core/filters/ex-date.filter";
import { IEcranDetailsResourcesEntite } from "../../../../../core/resources/ecran-details.resource";
import { IMenuItem } from "../../../../../core/services/menu/menu-item.service";
import { IMenuItemActionClass } from "../../../../../core/services/menu/menu-item-action.service";
//import { IMenuItemSelectionClass } from "../../../../../core/services/menu/menu-item-selection.service";
import { IFormulaireItemSautDeLigneClass } from "../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service";
import { INumberDataTypeClass } from "../../../../../core/services/data-types/number-data-type.service";
import { IDateDataTypeClass } from "../../../../../core/services/data-types/date-data-type.service";

interface IPageRc2001 {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    proMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
    execRetour: IMenuItem;
}
interface IRc2001Params {
    menuId: string;
    prpcleint: string;
}

/* @ngInject */
export default function Rc2001Controller(
    $state: IStateService,
    //Menu: IMenuClass,
    rc0001Route: IRoute,
    rc0002Route: IRoute,
    //$stateParams: any,
    $stateParams: IRc2001Params,
    MenuItemAction: IMenuItemActionClass,
    //MenuItemSelection: IMenuItemSelectionClass,
    exDateFilter: IFilterExDate,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    NumberDataType: INumberDataTypeClass,
    DateDataType: IDateDataTypeClass,

    ecranDetails: IEcranDetailsResourcesEntite,
) {
    const vm: IPageRc2001 = this;
    vm.valeursEcran = ecranDetails.valeurs;

     const DATA_TYPES = {
        NUMBER: new NumberDataType(), // Entier
        DATE: new DateDataType(),
        DECIMAL: new NumberDataType({
                                        params: {
                                            decimals: 4 // jusqu'à 4 chiffres apres la virgule
                                        }
                                    }),
    };

    // Usage d'imputation
    vm.execRetour = new MenuItemAction(
        "LBL_BTN_RECEPTION",
        "BOUREC",
        () => ({}),
        {
            iconButton: false,
            hidden: false,
            saveFirst: true,
            class: "ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised",
            formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_CREER_ENT',
                        lblConfirm: '',
                        largeurFormulaire: 50,
                formulaire: new Formulaire([
                    new FormulaireItem('intcleintmag'),
                    new FormulaireItem('txmnbrcolrec', { dataType: DATA_TYPES.DECIMAL }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('txmnumref', { largeur: 25, maxlength: 25, required: true }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('txmdat', { default: exDateFilter(new Date()), largeur: 25, maxlength: 25, dataType: DATA_TYPES.DATE }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('txmnbrcolliv', { dataType: DATA_TYPES.DECIMAL }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('txmnomtra', { largeur: 50, maxlength: 50 }),
                    new FormulaireItem('txmdsc', { default: 'Réception de marchandise', largeur: 50, maxlength: 50 }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('txmnumemb')
                ], { largeurDefaut: 50 })
            },
            successAction: (data: any) => {
                $state.go(getForageItem(data), {
                    id: data.doccleintnew,
                    intcleintmag: $stateParams.prpcleint,
                    menuId: $stateParams.menuId,
                });
            },
        },
    );

    vm.proMultiOccurrenceOptions = {
        editionRapideActive: true,
        fonctions: {
            editionRapide: true,
            editionStandard: true,
        },
        colonnesFixesGauche: [
            { nom: 'prplig', largeur: 100}
        ],
        colonnesVisibles: [
            { nom: "prpnumcat", largeur: 160 },
            { nom: 'procod', largeur: 140, hidden: ecranDetails.valeurs.flgpro },
            { nom: "prodsc", largeur: 180 },
            { nom: "forcod", largeur: 130 },
            { nom: "forachdsc", largeur: 200 },
            {
                nom: "forcod",
                largeur: 150,
                hidden: ecranDetails.valeurs.flgforinv,
            },
            {
                nom: "forinvdsc",
                largeur: 200,
                hidden: ecranDetails.valeurs.flgforinv,
            },
        ],
        colonnesFixesDroite: [
            { nom: 'diiprxunimov', largeur: 120 },
            { nom: 'qtedspmov', largeur: 120 },
            { nom: 'diiqtemovfor', largeur: 120 },
            { nom: 'prpflgsel', largeur: 120 }
        ],
        formulaire: new Formulaire([
                new FormulaireItem("prpnumcat"),
                new FormulaireItem("prodsc"),
                new FormulaireItem("forachcod", {hidden: ecranDetails.valeurs.flgforinv}),
                new FormulaireItem("forachdsc", {hidden: ecranDetails.valeurs.flgforinv}),
                new FormulaireItem("diiprxunimov"),
                new FormulaireItem("qtedspmov"),
                new FormulaireItem("diiqtemovfor"),
                new FormulaireItem("prpflgsel")
        ], {
            largeurDefaut: 33,
        }),

        colonnesEditionRapide: [
            { nom: 'prplig', largeur: 100},
            { nom: "prpnumcat", largeur: 100 },
            { nom: "prodsc", largeur: 150 },
            { nom: "forachcod", largeur: 130 },
            { nom: "forachdsc", largeur: 200 },
            {
                nom: "forachcod",
                largeur: 150,
                hidden: ecranDetails.valeurs.flgforinv,
            },
            {
                nom: "forinvdsc",
                largeur: 200,
                hidden: ecranDetails.valeurs.flgforinv,
            },
            { nom: 'diiprxunimov', largeur: 120 },
            { nom: 'qtedspmov', largeur: 120 },
            { nom: 'diiqtemovfor', largeur: 120 },
            { nom: 'prpflgsel', largeur: 120 }

        ],
        colonnesCachees: ["prpcleint", "vaesysmodcod"],
    };

    function getForageItem(data: any): string {
        if (data.flginv === 1) {
            return rc0002Route.NAME;
        } else {
            return rc0001Route.NAME;
        }
    }
}
